import tanvirulImage from "../../assets/team/tanvirul_islam.jpg";
import junaidulImage from "../../assets/team/junaidul_islam_new.jpg";
import tawhidulImage from "../../assets/team/tawhidul_hoque_ekon.jpeg";

// CodeJBorg is Md. Junaidul Islam's software studio. It's referenced from two
// places - the team section below (as one of his affiliations) and the
// Collab page (src/pages/Collab/Collab.js, as the design & build partner on
// select projects). Kept here as the single source of truth for its name and
// URL so the two pages can't drift out of sync.
export const CODEJBORG = {
    name: "CodeJBorg",
    url: "https://junaidul.pro.bd/codejborg",
};

// Team members for the "Meet the Creative Minds" section on the homepage.
//
// `affiliations` is a list of { role, org? } lines rendered under each
// member's name, in order, all with identical styling - nobody's affiliation
// is visually promoted over anyone else's. `org` is optional: omit it for a
// plain role (just text), or set it to { name, url } to make that org name a
// real link - internal (e.g. "/") or external.
export const teamMembers = [
    {
        id: 1,
        name: "Tanvirul Islam",
        initials: "TI",
        image: tanvirulImage,
        link: "https://behance.net/tanviruspixels",
        affiliations: [
            { role: "Founder", org: { name: "Arvix Creative", url: "/" } },
            { role: "Designer", org: { name: "July Revolution Alliance - JRA", url: "https://jrabd.org/" } },
            { role: "Designer", org: { name: "July Mass Uprising Memorial Museum", url: "https://july36.gov.bd/" } },
        ],
    },
    {
        id: 2,
        name: "Md. Junaidul Islam",
        initials: "JI",
        image: junaidulImage,
        link: "https://junaidul.pro.bd/",
        affiliations: [
            { role: "Founder", org: CODEJBORG },
            { role: "Software Engineer", org: { name: "BizSolution", url: "https://www.bizsolution.com.bd/" } },
            { role: "Former Software Engineer", org: { name: "eGeneration", url: "https://www.egeneration.co/" } },
        ],
    },
    {
        id: 3,
        name: "Tawhidul Hoque Ekon",
        initials: "TE",
        image: tawhidulImage,
        link: "https://tawhidekon.me/",
        affiliations: [
            { role: "Digital Marketing Expert" },
        ],
    },
];
